import { render } from "./AppHint.vue?vue&type=template&id=ba011d8e&scoped=true"
import script from "./AppHint.vue?vue&type=script&lang=js"
export * from "./AppHint.vue?vue&type=script&lang=js"

import "./AppHint.vue?vue&type=style&index=0&id=ba011d8e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba011d8e"]])

export default __exports__